
import * as React from "react";
import { observer } from "mobx-react";
import { action, observable } from "mobx";
import { ScreenMode } from "../../../models/enums";
import LegalStore from "../../../stores/legalStore";
import SeekerStore from "../../../stores/SeekerStore";
import Button from "material-ui/Button";
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle } from "material-ui/Dialog";


@observer
export default class PrivacyPolicyDlg extends React.Component<{ store: SeekerStore }, {}> {
  @observable agrees: boolean;
  constructor(props: any) {
    super(props);
    this.agrees = false;
  }
  @action setAgrees = (agrees: boolean): void => {
    this.agrees = agrees;
  }
  render(): JSX.Element {
    const ls: LegalStore = this.props.store.legal;
    const mode: ScreenMode = this.props.store.viewState.screenMode;

    return <Dialog
      open={this.props.store.legal.showPrivacy}
      aria-labelledby="responsive-dialog-title"
      fullScreen={mode === ScreenMode.Mobile} >
      <DialogTitle>{this.props.store.localization.fields.privacyDlg.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <div dangerouslySetInnerHTML={{ __html: ls.privacyText }}></div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={() => ls.hidePrivacyStatement()} >{this.props.store.localization.fields.close}</Button>
      </DialogActions>  
    </Dialog > 
  }
} 


// WEBPACK FOOTER //
// ./src/components/dialogs/privacyPolicy/index.tsx